module.exports = {"oneOf":[{"type":"object","optional":true,"required":["lastAccess","eTag","hitCount"],"properties":{"expires":{"type":"string"},"lastAccess":{"type":"string"},"eTag":{"type":"string"},"hitCount":{"type":"integer"},"comment":{"type":"string"}}},{"type":null,"additionalProperties":false}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/request-json/node_modules/har-validator/lib/schemas/cacheEntry.json
// module id = EzMT
// module chunks = 1